import React from 'react';
import {render} from 'react-dom';

var jsdiff = require('diff');
var jsdiff = require('diff');
const pako = require('pako');
const btoa = require("Base64").btoa;
const atob = require("Base64").atob;

var FileNames = React.createClass({
	getInitialState: function(){
		return {filesInfo: [], heightt: 320, "count": 0}
	},
	componentDidMount: function(){
		var filesInfo = [];
		var totalFiles = 0;
		var data = this.props.data;
		for (var i in data){
			var remote = "", local = "";
			if(data[i][Object.keys(data[i])[0]].remote !== "" && !data[i][Object.keys(data[i])[0]].remote.startsWith("http")){
				remote = this.toDecode(data[i][Object.keys(data[i])[0]].remote)
			}
			if(data[i][Object.keys(data[i])[0]].local !== "" && !data[i][Object.keys(data[i])[0]].local.startsWith("http")){
				local = this.toDecode(data[i][Object.keys(data[i])[0]].local)
			}
		   	var fileName = {};
		   	fileName.name = Object.keys(this.props.data[i])[0];
		   	if(local.length > 30000){
		   		local = local.slice(0,30000);
		   	}
		   	if(remote.length > 5000){
		   		remote = remote.slice(0,30000);
		   	}
		   	fileName.data = this.diff(local, remote);
		   	fileName.remote = data[i][Object.keys(data[i])[0]].remote;
		   	fileName.local = data[i][Object.keys(data[i])[0]].local
		   	fileName.check = false;
		   	filesInfo.push(fileName)
		   	totalFiles++;
		}
		this.setState({filesInfo: filesInfo});
		this.props.setActiveFile(filesInfo[0].name, filesInfo[0].data);
		this.props.totalFiles(totalFiles);
	},
	toDecode: function(str){
		let decodedData = atob(str);
		let inflated = pako.inflate(decodedData, { to: 'string' });
		return inflated;
	},
	diff: function(remote, local){
		return jsdiff.diffLines(remote, local, { "newlineIsToken" : true});
	},
	handleCrossClick: function(file){
		var filesInfo = this.state.filesInfo;
		for (var i in filesInfo){
		  if (filesInfo[i].name === file){
		      	filesInfo[i].check = false;
		   }
		}
		this.setState({	"filesInfo": filesInfo});
		this.countFiles(filesInfo);
	},
	handleCheckClick: function(file){
		var filesInfo = this.state.filesInfo;
		for (var i in filesInfo){
		  if (filesInfo[i].name === file){
		      	filesInfo[i].check = true;
		   }
		}
		this.setState({"filesInfo": filesInfo});
		this.countFiles(filesInfo);
	},
	countFiles: function(filesInfo){
		var count = 0;
		for (var i in filesInfo){
			if(filesInfo[i].check){
				count++;
			}
		}
		this.setState({count: count});
		this.props.countFiles(count);
	},
	handleFileNameClick: function(file, data){
		this.props.setActiveFile(file, data);
	},
	handlePushClick: function(){
		var pushFiles = [];
		for (var i in this.state.filesInfo){
			if(this.state.filesInfo[i].check){
				pushFiles.push(this.state.filesInfo[i].name);
			}
		}
		this.props.handlePushClick(false, pushFiles);
	},
	render: function(){
		var files = this.state.filesInfo, result = [];
		for (var i in files){
			var activeClass = "";
			if(files[i].check){
				activeClass = "diff-file__item diff__item--addition";
			} else {
				activeClass = "diff-file__item diff__item--deletion";
			}
			if(files[i].name === this.props.activeFile){
				activeClass = activeClass + " active"
			}
			result.push(<li className={activeClass}  onClick = {this.handleFileNameClick.bind(this, files[i].name, files[i].data)} key = {i}>
	                		<div className="diff-file__cell cell--first" onClick = {this.handleCrossClick.bind(this, files[i].name)}>
	                  			<button className="btn__md btn--close">
	                  				<i className="fa fa-close"> </i>
	                  			</button>
	                		</div>
	                		<div className="diff-file__cell cell--second" onClick = {this.handleCheckClick.bind(this, files[i].name)}>
	                  			<button className="btn__md btn--check">
	                  				<i className="fa fa-check"> </i>
	                  			</button>
	                		</div>
	                		<div className="diff-file__cell cell--third"> 
	                			<span className="diff__item--path">{files[i].name}</span> 
	                		</div>
          				</li>);
				}
		return(
			<div className="diff__col diff__col--left">
	          	<div className="diff-file" style = {{height: this.state.heightt + this.props.modifiedHeght + "px"}}>
	            	<ul className="diff-file__list list-unstyled">
	            		{result}
	            	</ul>
	          	</div>
	          	<div className ="diff-file__btns clearfix">
	          		{this.state.count > 0 ?
	            	<button className ="btn__lg bg-dark" onClick = {this.handlePushClick}>Push</button> :
	            	<button className ="btn__lg bg-dark" style = {{  "pointerEvents": "none", "cursor": "default", backgroundColor: "#3f85b3", "border": "1px solid #3f85b3"  }}>Push</button> }
	            	<button className ="btn__lg bg-very_light" onClick = {this.props.handleCloseClick}>Cancel</button>
	          	</div>
        	</div>
		);
	}

});

export {FileNames};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/DiffPushPopup/FileNames.jsx
 **/